export default __webpack_public_path__ + "static/violet-grid-f855dbf79b163191a39d997c7b6bf974.svg";